<template>
  <div class="px-1.5 py-2.5" v-if="familyDiscountOrders.length > 0">
    <div class="family-discount-order-info-header flex items-center">
      <img :src="image_base_url + 'orderTest/family_discount_icon_light.svg'" alt="Family Discount" class="mr-1.5" />
      <p>Family Discount Order Info:</p>
    </div>
    <div class="mt-2.5 flex flex-col gap-2.5">
      <FamilyDiscountOrderInfoCard 
        v-for="(order, index) in familyDiscountOrders" 
        :key="order.id" 
        :order="order" 
        :count="index + 1"
        :patient-name="order.patient.name"
        :gender="order.patient.gender"
        :birth-date="order.patient.birthDate"
        :original-price="order.tests[0].originalPrice"
        :price="order.tests[0].price"
        :test-name="getTestNameByLanguage(order.tests[0].id)"
        :test-name-list="getTestNameList(order.tests[0])"
        :total-count="familyDiscountOrders.length"
        @removeFamilyDiscountOrder="removeFamilyDiscountOrder(order)"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import FamilyDiscountOrderInfoCard from './FamilyDiscountOrderInfoCard.vue';
import { getTestNameList } from '../../order-page/order-summary/selected-tests-tab-pane';
import { getItemNameByLanguage } from '../../order-page/order-test-panel/order-test-tabs/testCard';
export default {
  inject: ['image_base_url'],
  components: {
    FamilyDiscountOrderInfoCard
  },
  computed: {
    ...mapState(["language"]),
    ...mapState("orderTest/familyDiscount", ["familyDiscountOrders"]),
    ...mapGetters("orderTest", ["orderTestSupportObj"])
  },
  methods: {
    getTestNameList(test) {
      return getTestNameList({...test, category: "vw"}, this.orderTestSupportObj, this.language).nameList;
    },
    getTestNameByLanguage(testId) {
      let testNode = this.orderTestSupportObj.testNodeList.find(test => test.id === testId);
      return getItemNameByLanguage(testNode.value, this.language);
    },
    removeFamilyDiscountOrder(order) {
      this.$store.dispatch("orderTest/familyDiscount/removeFamilyDiscountOrder", order);
      this.$store.dispatch("orderTest/familyDiscount/deselectFamilyMember", order.patient.id);
    }
  }
}
</script>

<style scoped>
.family-discount-order-info-header {
  color: #1B90AB;
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
  letter-spacing: 0.15px;
}
</style>